/**
 * OPUS-913 — Avatars (ported from the Claude Design handoff). UserAvatar renders
 * from profile.avatar = { type:'initials'|'preset', color, icon }; Avatar is the
 * simple initials/image circle. Plus the preset palette + icon set used by the
 * profile editor.
 */
import React from "react";
import { Icon } from "./Icon";

export const AVATAR_COLORS = ["#FF455C", "#45FFA7", "#58C4FF", "#C445FF", "#FCC144", "#5C6266", "#FF8A5B", "#2BD4A0"];
export const AVATAR_ICONS = ["users", "shield", "scene", "rendererList", "barChart", "target", "power", "play"];
export const PRESET_AVATARS = AVATAR_ICONS.map((icon, i) => ({ id: `p${i + 1}`, icon, color: AVATAR_COLORS[i] }));

function initialsOf(name) {
  return (String(name || "?").trim().split(/[\s_]+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase()) || "?";
}

export function UserAvatar({ profile, size = 40, square = true }) {
  const a = (profile && profile.avatar) || { type: "initials", color: "#FF455C" };
  const radius = square ? "30%" : "50%";
  if (a.type === "preset") {
    return (
      <div style={{ width: size, height: size, borderRadius: radius, flexShrink: 0, background: a.color, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon name={a.icon || "users"} size={size * 0.5} />
      </div>
    );
  }
  return (
    <div style={{ width: size, height: size, borderRadius: radius, flexShrink: 0, background: a.color || "#FF455C", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.4, fontWeight: 700, fontFamily: "var(--font-sans)" }}>
      {initialsOf(profile && profile.name)}
    </div>
  );
}

export function Avatar({ name = "", size = 34, color, square = false, src }) {
  return (
    <div style={{ width: size, height: size, borderRadius: square ? "30%" : "50%", flexShrink: 0,
      background: color || "var(--surface-3)", color: color ? "#fff" : "var(--text-muted)",
      display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.4, fontWeight: 700,
      fontFamily: "var(--font-sans)", border: color ? "none" : "1px solid var(--border)", overflow: "hidden" }}>
      {src ? <img src={src} alt={name} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : initialsOf(name)}
    </div>
  );
}

export default UserAvatar;
